import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { UserStore } from '../stores/user-store';

export const guestGuard: CanActivateFn = () => {
  const router = inject(Router);
  const userStore = inject(UserStore);

  // Si l'utilisateur est déjà connecté dans le store, rediriger vers home
  if (userStore.isLoggedIn()) {
    router.navigate(['/home']);
    return false;
  }

  return true;
};